module.exports = "/_next/static/images/PrivacyPortal@2x-4b0536358b7badb48962646542cfbaff.webp";